
import React from 'react';
import moment from 'moment';


const CreditCardSelectYear = ({ input, translate, meta: { touched, error, warning, asyncValidating } }) => {
  const options = []
   for (var i = 0; i < 10; i++) {
    const time = moment().add(i, 'Y').format("YYYY");
    options.push(<option key={time} value={time}>{time}</option>)
  }
  return(
    <div>
    <select {...input} className="form-control" size="size">
      <option value="" hidden="hidden"> </option>
      {options}
    </select>
    {touched && error && <div><span className="text-danger">{translate(error)}</span></div>}
    </div>
  )
}
export default CreditCardSelectYear;



// WEBPACK FOOTER //
// ./src/components/Payment/CreditCardSelectYear.js